import { AuditWrapper } from '../../../components/hub/AuditWrapper';
import { DataCloudPage } from '../../DataCloudPage';

export function HubDataCloudPage() {
  return (
    <AuditWrapper>
      <DataCloudPage />
    </AuditWrapper>
  );
}
